import { render, staticRenderFns } from "./nearby-customer.vue?vue&type=template&id=41075dd2&scoped=true"
import script from "./nearby-customer.vue?vue&type=script&lang=js"
export * from "./nearby-customer.vue?vue&type=script&lang=js"
import style0 from "./nearby-customer.vue?vue&type=style&index=0&id=41075dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41075dd2",
  null
  
)

export default component.exports